import React from 'react';
import './App.css';
import image from './images/background.png';
import logo from './Logo.svg';

function App() {
  return (
    <div className="background">
        <nav className="navbar navbar-expand-md navbar-dark nav-bg">
            <div className="container">
                <img className="logo" src={logo} alt="LOGO"/>
                {/*<a className="navbar-brand" href="#"><img src={logo} alt="LOGO"/></a>*/}
                <button className="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ml-auto mr-5">
                        <li className="nav-item">
                            <a className="nav-link" href="#">Home</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#">Accessories </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#">Tutor</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#">One-O-One</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#">Register</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#">Login</a>
                        </li>
                    </ul>
                </div>
            </div>
         </nav>
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    <div className="box-margin">
                        <h1 className="display">
                            Bring Your Gym to Your Home
                        </h1>
                        <p>
                            <span>GymAdda</span> is a place where you can access your Gym at our Home. GymAdda provides you Online classes with your One-O-One Mentor that helps you in exercise and also provides you to all the equipment and accessories that used in gym. So what are you waiting for, grab your phone and place a tutor for training.
                        </p>
                        <p>
                            A gym is a place with number of equipment's and machines used by the people to do exercises.  "Gym" is also slang for "fitness centre", which is often an area for indoor recreation.
                        </p>
                        <img src={logo} alt="LOGO"/>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="box d-flex align-items-center justify-content-center">
                        <img className="box-image" src={image} alt="Image"/>
                    </div>
                </div>
            </div>
        </div>
        <div className="container fixed-bottom">
            <p>Design by- <span>Aayush Soni</span></p>
        </div>
    </div>
  );
}

export default App;
